import LoadingCircle from '../components/LoadingCircle';

export default class CancelPlan {

    constructor() {

        this.cancelPlanBtn = $('#cancel-plan-modal-btn')
        this.clicks=0;
        this.events()
        this.onLoad()

    }

    events() {

        this.cancelPlanBtn.on('click', e => this.cancelPlan(e))
    }

    onLoad() {

    }

    cancelPlan(e) {
        this.clicks++;
        console.log(this.clicks);
        if(this.clicks==1){
            let loading_circle = new LoadingCircle()
            $('#cancel-cancel-plan-modal-btn').addClass('invisible')
            $('#cancel-plan-modal .modal-header button.close').addClass('invisible')
            loading_circle.buttonShow($(e.currentTarget))
    
            axios.post(`/ajax/cancel-subscription`).then(res => {}).catch(err => {}).finally(() => {
                $('#cancel-plan-modal').modal('hide')
                location.reload();
            })
        }
    }

}
